<template>
	<div class="artist-data">
		<NewTabLink :linkURL="artistURL" :text="artist"></NewTabLink>
	</div>
</template>

<script>
import NewTabLink from "../NewTabLink.vue";

export default {
	components: {
		NewTabLink,
	},
	props: {
		artist: {
			type: String,
			required: true,
		}, 
		artistURL: {
			type: String,
			default: "#",
		},
		banner: {
			type: String,
		},
	},
}
</script>

<style scoped>
	.artist-data {
		display: inline-block;
	}
</style>
